import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Typography } from '@mui/material';

import { RootState } from '../../../../../lib/store';
import { PriceChangeDirection } from '../../../../../lib/store-util/priceTypes';
import { getPriceColorByDirection } from '../../../../../lib/util/ChartingHelpers';
import { formatCurrency } from '../../../../../lib/util/DataHelpers';

import { ChartLine } from '../../../../../shared_components/ChartLine';
import ClickableDiv from '../../../../../shared_components/ClickableDiv/ClickableDiv';
import { UI_ROUTES } from '../../../../../util/routes';
import CompanyLogo from '../../../../CompanyLogo/CompanyLogo';
import { TradePrice } from '../../PeopleAlsoTrade.types';

import styles from './PeopleAlsoTradeCard.module.scss';

type Props = {
  data: TradePrice;
  handleClickCard: () => void;
};

const PeopleAlsoTradeCard = ({ data, handleClickCard }: Props) => {
  const navigate = useNavigate();
  const { symbol, currentPrice, direction, changePercent, url } = data;
  const directionColor = getPriceColorByDirection(direction as PriceChangeDirection);
  const companyLogoAndNameData = useSelector(
    (state: RootState) => state.fundamental.companyLogoAndName,
  );

  const handleClick = () => {
    handleClickCard();
    navigate(`${UI_ROUTES.symbol}/${symbol}`);
  };

  return (
    <div className={styles.container}>
      <ClickableDiv className={styles.card} onClick={() => handleClick()}>
        <div className={styles.header}>
          <div>
            <CompanyLogo
              url={url || companyLogoAndNameData[symbol]?.url}
              logo={companyLogoAndNameData[symbol]?.logo || ''}
              symbol={symbol}
            />
          </div>
          <Typography noWrap className={styles.companyName}>
            {symbol}
          </Typography>
        </div>
        <div className={styles.chart}>
          <ChartLine symbol={symbol} isChartInCard />
        </div>
        <div className={styles.footer}>
          <p className={styles.priceAndChange}>{formatCurrency(currentPrice)}</p>
          <p className={styles.priceAndChange} style={{ color: directionColor }}>
            {direction === '-' ? `-${changePercent}` : `+${changePercent}`}
          </p>
        </div>
      </ClickableDiv>
    </div>
  );
};

export default PeopleAlsoTradeCard;
